import React, { useState, useEffect, useRef } from "react";
import VisibilitySensor from "react-visibility-sensor";
import {
  getVisibleSensorAnimation,
  setAdditionalClasses,
} from "../assets/js/utils";
import InteractiveIcon from "./InteractiveIcon";
import BiladImage from "../assets/images/bilad-word.svg";
import { useSelector } from "react-redux";

function InteractiveTable({
  title,
  icons,
  contents,
  width = "100%",
  redFilledStyle,
  height = "100%",
  applyBoxShadow,
}) {
  const [activeIndex, setActiveIndex] = useState(0);
  const [applyAnimationOnIndexChange, setApplyAnimationOnIndexChange] =
    useState(false);

  const generalSettings = useSelector((state) => state.ui.generalSettings);

  useEffect(() => {
    setApplyAnimationOnIndexChange(true);
    setTimeout(() => {
      setApplyAnimationOnIndexChange(false);
    }, 700);
  }, [activeIndex]);
  return (
    <div
      className={`interactive-table${setAdditionalClasses(
        ["apply-box-shadow11"],
        [applyBoxShadow]
      )}`}
      style={{ width, height }}
    >
      <div
        className={`interactive-table__header${setAdditionalClasses(
          ["interactive-table__header--red-filled"],
          [redFilledStyle]
        )}`}
      >
        <h4 className="interactive-table__heading">{title}</h4>
        {!redFilledStyle && (
          <VisibilitySensor partialVisibility>
            {({ isVisible }) => (
              <img
                src={require("../assets/images/interactive-table-header.png")}
                alt=""
                className="interactive-table__header-icon"
                style={getVisibleSensorAnimation(
                  isVisible,
                  generalSettings.rtlLanguage
                    ? "move-from-left-to-right-flipped 1.3s"
                    : "move-from-left-to-right 1.3s"
                )}
              />
            )}
          </VisibilitySensor>
        )}
      </div>
      <VisibilitySensor partialVisibility>
        {({ isVisible }) => (
          <div style={{ overflow: "hidden", height: "auto" }}>
            <div
              className={`interactive-table__body${setAdditionalClasses(
                ["interactive-table__body--red-filled"],
                [redFilledStyle]
              )}`}
              style={getVisibleSensorAnimation(
                isVisible,
                "menu-appear 1s ease-out"
              )}
            >
              {icons && (
                <div className="interactive-table__icons">
                  {icons.map((icon, index) => (
                    <div
                      className="interactive-table__icon"
                      style={getVisibleSensorAnimation(
                        isVisible,
                        `bounce-inter 0.5s ${0.75 + index * 0.25}s backwards`
                      )}
                    >
                      <InteractiveIcon
                        key={index}
                        icon={index === activeIndex ? icon[1] : icon[0]}
                        onPress={() => setActiveIndex(index)}
                        active={index === activeIndex}
                      />
                    </div>
                  ))}
                </div>
              )}
              <div
                className={`interactive-table__content${setAdditionalClasses(
                  ["animate-tab-interactive-icons-selector"],
                  [applyAnimationOnIndexChange]
                )}`}
              >
                {contents[activeIndex]}
                {redFilledStyle && (
                  <img
                    src={BiladImage}
                    alt=""
                    className="interactive-table__image-red-filled"
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </VisibilitySensor>
    </div>
  );
}

export default InteractiveTable;
